import React, { Component } from 'react';
import fetch from '../../support/fetch';
import AuthenticatedTemplate from "../../Components/Templates/Authenticated/index";
import { Card, Grid, Dimmer, Form, Button } from 'tabler-react';
import EmailInput from '../../Components/Playgrond/EmailInput';
import CardAlert from '../../Components/CardAlert';

class ChangeEmail extends Component {
    state = {
        showLoader: false,
        alertText: '',
        alertColor: 'danger',
        user: {},
        values: {}
    };

    componentDidMount() {
        this.setState({
            user: JSON.parse(sessionStorage.getItem('ooppah_user_info'))
        })
    };

    onChangeHandler = e => {
        this.setState(prevState => ({
            values: {
                ...prevState.values,
                [e.target.name]: e.target.value
            }
        }))
    };

    submitHandler = e => {
        e.preventDefault();

        this.setState({showLoader: true});

        fetch.obj({
            query: `mutation ChangeEmail($email: String!, $new_email: String!, $new_email_confirmation: String!) {
                changeEmail(email: $email, new_email: $new_email, new_email_confirmation: $new_email_confirmation) {
                    id
                    email
                }
            }`,
            variables: {
                email: this.state.user.email,
                new_email: this.state.values.new_email,
                new_email_confirmation: this.state.values.new_email_confirmation,
            }
        })
        .then(res => {
            if (res.hasOwnProperty('errors') && res.errors[0].hasOwnProperty('validation')) {
                const lastErrorKey = Object.keys(res.errors[0].validation)[0];

                this.setState({
                    alertText: res.errors[0].validation[lastErrorKey][0]
                })
            }

            this.setState(prevState => ({
                user: {
                    ...prevState.user,
                    email: this.state.values.new_email
                }
            }), () => {
                sessionStorage.setItem('ooppah_user_info', JSON.stringify(this.state.user));
                window.location = '/home'
            });

            this.setState({showLoader: false});
        });
    };

    render() {
        return (
            <AuthenticatedTemplate title="Alterar E-mail">
                <Grid.Row>
                    <Grid.Col md="7">
                        <form method="POST" onSubmit={this.submitHandler} autoComplete="off">
                            <Card>
                                <Card.Body>
                                    <CardAlert color={this.state.alertColor} >{this.state.alertText}</CardAlert>
                                    <Dimmer active={this.state.loading} loader={this.state.loading}>
                                        <p className="lead">
                                            Informe o e-mail que você gostaria de utilizar para receber as{' '}
                                            Notificações de atividades da sua conta.
                                        </p>
                                        <Form.Group label="Novo E-mail">
                                            <EmailInput
                                                name="new_email"
                                                required
                                                onChange={this.onChangeHandler}
                                                disabled={this.state.showLoader}
                                            />
                                        </Form.Group>

                                        <Form.Group label="Novo E-mail - Confirmação">
                                            <EmailInput
                                                name="new_email_confirmation"
                                                required
                                                onChange={this.onChangeHandler}
                                                disabled={this.state.showLoader}
                                            />
                                        </Form.Group>

                                        <Button
                                            outline={!this.state.showLoader}
                                            color="info"
                                            block size="lg"
                                            className="mt-6"
                                            loading={this.state.showLoader}
                                            disabled={this.state.showLoader}
                                        >
                                            Alterar meu E-mail
                                        </Button>
                                    </Dimmer>
                                </Card.Body>
                            </Card>
                        </form>
                    </Grid.Col>
                </Grid.Row>
            </AuthenticatedTemplate>
        );
    }
}

export default ChangeEmail;
